.invisible {
  visibility: hidden;
}

.textAlignWebkitCenter {
  text-align: -webkit-center;
}
